import React from 'react';
import { useSeparator } from 'react-aria';
import * as S from './styles';
import { DividerProps } from './types';

/**
 * A line used to separate elements within a component
 */
const Divider: React.FC<DividerProps> = ({
  children,
  className,
  color,
  gutter = 0,
  space = 'small',
  ...props
}) => {
  const element: React.ElementType = !children ? 'hr' : 'div';

  const { separatorProps } = useSeparator({
    ...props,
    elementType: element,
  });

  if (!children) {
    // S.Root is already a styled hr, but passing it with the `as` props reinforces
    // the relationship between the element rendered and the element passed to
    // useSeparator
    return (
      <S.Root
        as={element}
        className={className}
        $color={color}
        $gutter={gutter}
        $space={space}
        {...separatorProps}
      />
    );
  }

  return (
    <S.Root
      as={element}
      className={className}
      $color={color}
      $gutter={gutter}
      hasChildren={!!children}
      $space={space}
      {...separatorProps}
    >
      <S.ChildContainer>{children}</S.ChildContainer>
    </S.Root>
  );
};

export default Divider;
